//@flow
import * as React from 'react';
import { connect } from 'react-redux';
import Footer from '../../components/Footer/Footer';
import { SelectPerfilForm } from './SelectPerfilForm';
import { withRouter } from 'react-router-dom';

class SelectPerfilPage extends React.Component {
  constructor(props) {
    super(props);

    let cpf = '';
    if (
      props.location &&
      props.location.state &&
      props.location.state.cpf
    ) {
      cpf = props.location.state.cpf;
    } else {
      console.warn('⚠️ Nenhum CPF recebido via location.state');
    }

    this.state = {
      cpf,
    };
  }

  render() {
    const { cpf } = this.state;

    return (
      <React.Fragment>
        <div className="container-fluid d-flex h100 back-elements">
          <div className="background-lines">
            <div className="bg-riscos"></div>
          </div>

          <div className="card login">
            <SelectPerfilForm cpf={cpf} />
            <hr />
          </div>
        </div>
        <Footer />
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { loggedIn } = state.authentication;
  const { alert } = state;

  return {
    loggedIn,
    alert,
  };
}

const mapDispatch = ({
  alert: { error, clear, success, warning },
  load: { loading },
}) => ({
  error: (message, code) => error({ message, code }),
  clear: () => clear(),
  success: (msg) => success(msg),
  warning: (msg) => warning(msg),
  loading: (load: boolean) => loading({ load }),
});

export default connect(
  mapStateToProps,
  mapDispatch
)(withRouter(SelectPerfilPage));
